<template>

    <div class="comment"
         :class=" getCommentClass() "
         :data-comment-id="commentData.id"
         itemprop="commentTime"
         :dateCreated="commentData?.dateCreatedIso ?? ''"
         :id=" 'commentaire-' + commentData.id ">

        <div v-html="getCommentConnector()" v-if="commentLevel > 1"/>

        <div class="comment-inner" :id="`comment-${commentData.id}`">
            <div class="top-row">
                <div class="meta">
                    <a v-if=" ( commentAuthor?.id ?? 0 )  > 0 "
                       class="user-link user-profile-popup"
                       href="#profil"
                       :data-user-type="userType"

                       :data-user-id=" commentAuthor?.id ?? 0 ">
                        <Avatar :user="commentAuthor ?? false"></Avatar>
                    </a>
                    <div class="username-comment-date"
                         v-if=" ( commentAuthor?.id ?? 0 )  > 0 ">
                        <a class="user-link user-profile-popup"
                           href="#profil"
                           :data-user-type="userType"
                           :data-user-id=" commentAuthor?.id ?? 0 ">
                            <span class="username" data-user>{{
                                    maybeTrimText( commentAuthor?.name ??
                                        'Utilisateur inconnu' )
                                }}</span>
                            <span class="mod-icon-container" v-if="isAuthorModerator()"><img
                                :src="logoRougeNoTextSrc" alt="Icône de modérateur"
                                :title=" copydeck.isModHint.fr "></span>
                        </a>
                        <span class="comment-datetime"
                              v-html=" getPrettyCommentDate( commentData.dateCreatedIso )"></span>
                    </div>


                    <p v-if=" ( commentAuthor?.id ?? 0 )  < 1 "
                       class="user-link user-profile-no-popup">
                        <Avatar :user="commentAuthor ?? false"></Avatar>
                    </p>
                    <div class="username-comment-date"
                         v-if=" ( commentAuthor?.id ?? 0 )  < 1 ">
                        <p class="user-link user-profile-no-popup">
                            <span class="username">{{
                                    maybeTrimText( commentAuthor?.name ?? 'Utilisateur inconnu' )
                                }}</span>
                            <span class="mod-icon-container" v-if="isAuthorModerator()"><img
                                :src="logoRougeNoTextSrc" alt="Icône de modérateur"
                                :title=" copydeck.isModHint.fr "></span>
                        </p>
                        <span class="comment-datetime"
                              v-html=" getPrettyCommentDate( commentData.dateCreatedIso )"></span>
                    </div>
                </div>
                <div class="report-section">
                    <a href="#report"
                                               class="btn btn-report-comment"
                                               @click.prevent="toggleCommentReportModal"
                                               :disabled="!commentData.id"
                                               :title=" copydeck.reportCommentBtn.fr "></a>

                </div>
            </div>
            <div class="quote">
                <div class="quote-content" v-html="commentData.comment"></div>
            </div>

            <div class="bottom-row reactions-are-closed">


                <Reactions
                    :postType=" 'comments' "
                    :postId="commentData.id"
                    :reactions="commentData.reactions"
                    :rootPostType="rootPostType"
                    :rootId="rootId"
                    :commentParentId="commentData.id_comment_parent"
                    v-if="'jeunes' === store.getters.audienceMode"
                    :canContract="true"
                ></Reactions>

                <button type="button"
                        v-if="topLevelComment"
                        class="btn btn-comment-reply"
                        :disabled="!commentData.id"
                        @click.prevent="toggleFormOpen()"
                >Répondre
                </button>

                <button type="button"
                        class="btn btn-toggle-child-comments"
                        v-if="numChildComments > 0"
                        v-html="getPrettyNumberChildReplies()"
                        @click.prevent="toggleChildrenOpen()"></button>
            </div>

            <comment-form
                v-if="formOpen"
                :formOpenClass="formOpenClass"
                :commentData="commentData"
                :postType="postType"
                :postId="postId"
                :key=" commentData.id +  '_comment_form' "
                :commentLevel="commentLevel"
                :commentParentId="commentData.id"
                @fermemoi="forceFormClosed"
            ></comment-form>

            <div class="comment-bg second-level" role="presentation">
                <div class="bg-colour"></div>
            </div>
        </div>

        <div class="child-comments"
             :class="childrenClass"
             ref="childCommentsContainer"
             v-if="commentData?.child_comments?.length > 0 ?? false">

            <comment
                v-for="(childComment, index) in commentData.child_comments"
                :key="childComment.id"
                :commentData="childComment"
                :topLevelComment="false"
                :commentLevel="commentNextLevel"
                :parentId="commentData.id_comment_parent"
                :postType="postType"
                :postId="postId"
                :rootPostType=" rootPostType "
                :rootId=" rootId "
            ></comment>
        </div>


        <div class="comment-bg" role="presentation">
            <div class="bg-colour"></div>
        </div>
    </div>


</template>
<script>

export default {
    name : "Comment",
}

</script>
<script setup>
import { uniqueId }              from 'lodash-es';
import {
    onMounted,
    computed,
    ref,
}                                from 'vue';
import { useStore }              from "vuex";
import { smoothScrollTo }        from '../composables';

// components
// import { childCommentsComponent }                                           from "./Comment";
import Avatar                    from "./Avatar.vue";
import CommentForm               from "./CommentForm.vue";
import Reactions                 from "./Reactions.vue";
import ReportComment             from "./ReportComment.vue";
import {
    freezeBodyScroll,
    unfreezeBodyScroll,
    isUserLoggedIn,
    isUserProf, maybeTrimText,
}                                from '../../Utils';
import {
    format,
    render,
    cancel,
    register,
}                                from 'timeago.js';
import { getCommentConnector }   from '../composables';
import { printf }                from "fast-printf";
import { usePrettyDateInterval } from "../../components/composables/usePrettyDateInterval.js";

const logoRougeNoTextSrc = new URL( '../../../../images/logo-rouge-no-text.svg', import.meta.url ).href;


let store    = useStore();
let copydeck = computed( () => store.state.copydeck );


let props = defineProps( [
    "commentData",
    "topLevelComment",
    "commentLevel",

    "rootPostType",
    "rootId",
] );


let getPrettyCommentDate = usePrettyDateInterval();


let commentData      = computed( () => props.commentData );
let childComments    = computed( () => props.commentData?.child_comments ?? false );
let numChildComments = computed( () => props.commentData?.child_comments?.length ?? 0 );

let postType = computed( () => store.getters.mainContentType ?? 'posts' );
let postId   = computed( () => store.getters.mainContentId ?? 0 );


let rootPostType = computed( () => props.rootPostType );
let rootId       = computed( () => props.rootId );

let topLevelComment  = computed( () => props.topLevelComment );
let commentLevel     = computed( () => props.commentLevel );
let commentNextLevel = computed( () => props.commentLevel + 1 );

let commentAuthor = computed( () => props.commentData.user );
let currentUser   = computed( () => store.state.currentUser );
let userType      = computed( () => commentData.value.user.isAuthor ? "user-author" : "user" );

let commentAuthorId  = ref( false );
let commentAuthorUrl = ref( false );

let childrenOpen  = ref( false );
let childrenClass = computed( () => ref( childrenOpen ).value ? ' children-open ' : ' children-closed ' );


let formOpen      = ref( false );
let formOpenClass = computed( () => ref( formOpen ).value ? ' form-open ' : ' form-closed ' );

let componentReady = ref( false );

let childCommentsContainer = ref( null );

let isCommentReportOpen = ref( false );


function prettyDateLocale ( number, index )
{
    return [
        [ "à l'instant", 'dans un instant' ],
        [ 'il y a %s secondes', 'dans %s secondes' ],
        [ 'il y a 1 minute', 'dans 1 minute' ],
        [ 'il y a %s minutes', 'dans %s minutes' ],
        [ 'il y a 1 heure', 'dans 1 heure' ],
        [ 'il y a %s heures', 'dans %s heures' ],
        [ 'il y a 1 jour', 'dans 1 jour' ],
        [ 'il y a %s jours', 'dans %s jours' ],
        [ 'il y a 1 semaine', 'dans 1 semaine' ],
        [ 'il y a %s semaines', 'dans %s semaines' ],
        [ 'il y a 1 mois', 'dans 1 mois' ],
        [ 'il y a %s mois', 'dans %s mois' ],
        [ 'il y a 1 an', 'dans 1 an' ],
        [ 'il y a %s ans', 'dans %s ans' ],
    ][ index ];

}

register( 'fr-CA', prettyDateLocale );


function prettyDateInterval ( comment )
{
    const dtNow     = DateTime.local( { zone : 'America/Toronto' } )
    const dtComment = DateTime.fromISO( comment.dateCreatedIso, { zone : 'America/Toronto' } );

    const intervalSinceMinutes = Math.floor( dtNow.diff( dtComment, 'minutes' ).toObject().minutes );
    const intervalSinceHours   = Math.floor( dtNow.diff( dtComment, 'hours' ).toObject().hours );
    const intervalSinceDays    = Math.floor( dtNow.diff( dtComment, 'days' ).toObject().days );

    console.log( {
        dtNow,
        dtComment,
        intervalSinceMinutes,
        intervalSinceHours,
        intervalSinceDays,
    } )


    if ( intervalSinceDays >= 1 )
    {

        if ( intervalSinceDays === 1 )
        {
            return 'il y a un jour';
        } else
        {
            return printf( 'il y a %d jours', intervalSinceDays )
        }

    } else if ( intervalSinceHours >= 1 )
    {
        if ( intervalSinceHours === 1 )
        {
            return 'il y a une heure';
        } else
        {
            return printf( 'il y a %d heures', intervalSinceHours )
        }
    } else
    {
        if ( intervalSinceMinutes === 1 )
        {
            return 'il y a une minute';
        } else
        {
            return printf( 'il y a %d minutes', intervalSinceMinutes )
        }
    }
}


function prettyDateOld ( comment )
{
    const strElapsed = format( comment.localDate * 1000, "fr-CA" );

    const options = { weekday : 'long', year : 'numeric', month : 'long', day : 'numeric' };

    const commentDate = new Date( comment.localDate * 1000 );
    const strDate     = commentDate.toLocaleDateString( "fr-CA", options );
    const strTime     = commentDate.toLocaleTimeString( "fr-CA", { timeStyle : "short" } );

    return `${strElapsed} - ${strDate} - ${strTime}`;
}

function toggleChildrenOpen ()
{
    childrenOpen.value = !childrenOpen.value;

    if ( childrenOpen.value )
    {
        smoothScrollTo( ref( childCommentsContainer ).value, -150 );
    }
}

function toggleFormOpen ()
{

    if ( !isUserLoggedIn() )
    {

        if ( "profs" === store.getters.audienceMode )
        {
            const event = new Event( 'openExplanationProfsSeulement' );
            window.dispatchEvent( event );
        } else
        {


            const event = new Event( 'openExplanationJeunes' );
            window.dispatchEvent( event );

        }

        return;
    } else if ( !isUserProf() && "profs" === store.getters.audienceMode )
    {
        const triggerEvent = new Event( 'openExplanationJeunesActionProfsSeulement' );
        window.dispatchEvent( triggerEvent );
        return;

    } else if ( isUserProf() && "jeunes" === store.getters.audienceMode )
    {
        const event = new Event( 'openExplanationProfs' );
        window.dispatchEvent( event );

        console.log( 'User is a teacher. Popping explanation modal.', AsGlobalSettings );

        return;
    }

    formOpen.value     = !formOpen.value;
    childrenOpen.value = true;
}


function forceFormClosed ()
{


    console.log( 'COMMENT:  about to close the form', arguments );
    formOpen.value = false;
}

async function mounted ()
{
    commentAuthorId  = commentAuthor?.value?.id ?? 0;
    commentAuthorUrl = commentAuthor?.value?.url ?? '#profil';

    componentReady = true;

    let hash   = window.location.hash;
    let isHash = hash.includes( 'commentaire-' + commentData.value.id );

    if ( isHash )
    {
        let strSelector = `#comment-${commentData.value.id}`;

        console.log( strSelector );
        smoothScrollTo( strSelector, -150 );
    }

}

function getCommentClass ()
{


    let classes = [];
    classes.push( 'comment-level_' + commentLevel.value );


    if ( isAuthorModerator() )
    {
        classes.push( 'is-mod' );
    } else if ( isAuthor() )
    {
        classes.push( 'is-mod' );
    }

    if ( isCommentReportOpen )
    {
        classes.push( 'take-me-higher' );
    }

    if ( commentData?.value?.user?.isProf ?? false )
    {
        classes.push( 'is-prof-comment' );
    } else
    {
        classes.push( 'is-jeune-comment' );
    }


    return classes.join( ' ' );
}

function isAuthorModerator ()
{
    return commentAuthor?.value?.isModerator ?? false;
}

function isAuthor ()
{
    return commentAuthor?.value?.isAuthor ?? false;
}

function getPrettyNumberChildReplies ()
{

    if ( childrenOpen.value )
    {
        return copydeck.value.btnCloseChildComments.fr;
    }


    if ( numChildComments.value < 1 )
    {
        return '';

    } else if ( numChildComments.value === 1 )
    {
        return '1 réponse';
    }

    return numChildComments.value + ' réponses';


}


function toggleCommentReportModal ()
{

    /**
     * 2024-06-14 : Client aimerait que les profs puissent signaler les commentaires des jeunes
     *
     if ( isUserProf() && "jeunes" === store.getters.audienceMode )
     {
     const triggerEvent = new Event( 'openExplanationProfs' );
     window.dispatchEvent( triggerEvent );
     return;

     } else
     */


    if ( isUserLoggedIn() && !isUserProf() && "profs" === store.getters.audienceMode )
    {
        const triggerEvent = new Event( 'openExplanationJeunesActionProfsSeulement' );
        window.dispatchEvent( triggerEvent );
        return;

    } else if ( !isUserLoggedIn() && store.getters.audienceMode === "profs" )
    {
        const event = new Event( 'openExplanationProfsSeulement' );
        window.dispatchEvent( event );

        // console.log( 'User was not logged in. Popping Login modal.', AsGlobalSettings );

        return;
    } else if ( !isUserLoggedIn() && store.getters.audienceMode === "jeunes" )
    {
        const event = new Event( 'openExplanationJeunes' );
        window.dispatchEvent( event );

        // console.log( 'User was not logged in. Popping Login modal.', AsGlobalSettings );

        return;
    }

    store.commit( "changeReportCommentId", commentData.value.id );
    store.commit( "openReportingModal" );

}


onMounted( mounted );


function logit ()
{
    //console.log( 'On s\'est rendu' );
}

</script>

<style scoped>

</style>
